import React from 'react';
import GpyComponent from './GpyComponent'
import {__GPYPost} from '../../../env.js'
class GpyGameLog extends GpyComponent {

  constructor(props) {
      super(props);
      this.state = {
        gameLog: undefined,
        disabled:"",
      };
    }

    tick() {
      __GPYPost('getGameLog',{gamePk:this.props.game.id}, (res) => {

        res.GameLog.elements.forEach((e) =>  {
             e.dataObj = JSON.parse(e.data);
             if(e.dataObj !== undefined &&  e.dataObj.player !== undefined) {
               e.playerId = e.dataObj.player.id;
             } else {
               e.playerId = -1;
             }
        });

        this.setState({gameLog:res})
      });
    }

    init() {
      __GPYPost('getGameLog',{gamePk:this.props.game.id}, (res) => {
        res.GameLog.elements.forEach((e) =>  {
             e.dataObj = JSON.parse(e.data);
             if(e.dataObj !== undefined &&  e.dataObj.player !== undefined) {
               e.playerId = e.dataObj.player.id;
             } else {
               e.playerId = -1;
             }
        });
        this.setState({gameLog:res},()=>{if(this.props.onLoad!==undefined)this.props.onLoad(res);})
      });
    }

    componentDidMount(){
      if(this.props.scoreboard !== undefined && this.props.scoreboard.registerComponent !== undefined){
         this.props.scoreboard.registerComponent(this.props.stateName,this);
      };
      this.interval = setInterval(() => this.tick(), (30*1000));
      this.init();
    }

    remove(id) {
      this.setState({disabled:" disabled"},()=>{
          __GPYPost('removeGameLogElement',{elementPk:id,gamePk:this.props.game.id}, (res) => {
            this.setState({gameLog:res,disabled:""});
          });
      });
    }

    render () {
      if(this.state.gameLog === undefined) {
          return "";
    }

  		return (
              <div className="row" style={{backgroundColor:"#aaa"}}>
                <div className="col-8 p-1"><strong>Log </strong> </div>
                <div className="col-4 p-1 text-right"><button title="force reload log" className="btn btn-light btn-sm" onClick={()=>{	this.tick(); }}><span className="glyphicon glyphicon-refresh" aria-hidden="true"></span></button></div>
                <div className="col-12 p-1" style={{height:"300px",overflowY: "scroll"}}>
                  <div className="list-group">
                    {this.state.gameLog.GameLog.elements.map((e) =>  {
                      var minF = (parseInt(e.timerOffset)/1000) / 60 ;
                      var minI = Math.floor(minF) ;
                      var sec = Math.floor((minF-minI)*60);
                      var formatMin = ('00'+minI).slice(-2);
                      var formatSec = ('00'+sec).slice(-2);
                      return (
                        <div key={e.id} className={"list-group-item list-group-item-action list-group-item-"+e.mark+" flex-column align-items-start"+this.state.disabled} style={{padding: "0.0rem 0.00rem"}}>
                           <div className="d-flex w-100 justify-content-between">
                             <span style={{fontSize: "10px"}} className="text-monospace">{formatMin}:{formatSec} - {this.props.game.teamMap.HOME_TEAM.id === parseInt(e.team)?this.props.game.teamMap.HOME_TEAM.name : this.props.game.teamMap.GUEST_TEAM.id === parseInt(e.team)?this.props.game.teamMap.GUEST_TEAM.name:""} - {e.key} - {e.value}</span>
                             <small><button type="button" onClick={this.remove.bind(this,e.id)} className={"btn btn-light btn-sm"+this.state.disabled}><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></button></small>
                           </div>
                        </div>
                       )
                    })}
                </div>
            </div>
        </div>
  		);
    }
}
export default GpyGameLog;
